<template>
  <div class="batch-edit add-page">
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="120px" :hide-required-asterisk="false">
        <div @keyup.enter.stop="save()">
          <div>考生基本信息</div>
          <el-form-item label="证件照">
            <el-input class="none" type="text" v-model="form.officialPhoto" :maxlength="1024"></el-input>
            <div v-if="form.officialPhoto2">
              <el-image :src="form.officialPhoto2" :preview-src-list="[form.officialPhoto2]" class="border" style="height: 100px;margin-top: 10px;"></el-image>
            </div>
            <el-upload class="inline-block" style="margin-top: 10px;" action="" :http-request="userUploadOSS" :show-file-list="false" accept=".png,.jpg">
              <el-button type="default" style="color: #1890FF;margin-left: 0px;">上传证件照</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="考生姓名" prop="examineeName" :rules="[$validate.string(20)]">
            <el-input v-model="form.examineeName" @blur="toPinyin" :maxlength="20" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="姓名拼音" prop="examineeNameSpell" :rules="[$validate.string(200)]">
            <el-input v-model="form.examineeNameSpell" :maxlength="200" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="考生性别" prop="examineeSex" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.examineeSex">
              <el-radio v-for="(item,key) in $enums.sex" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="出生日期" prop="birthday2" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-date-picker v-model="form.birthday2" type="date" value-format="yyyy-MM-dd" default-time="00:00:00" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <!--          <el-form-item label="国籍" prop="countryCode" :rules="[{required: true, message: '请选择', trigger: 'change'}]">-->
          <!--            <el-select v-model="form.countryCode" placeholder="选择国籍" filterable clearable style="width: 200px;margin-right:10px;">-->
          <!--              <el-option v-for="(item,index) in $enums.countryCode" :key="index" :label="item.desc" :value="item.code" :class="item.disabled?'none':''"></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item label="民族" prop="nationalityCode" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-select v-model="form.nationalityCode" placeholder="选择民族" filterable clearable style="width: 200px;margin-right:10px;">
              <el-option v-for="(item,index) in nationalityList" :key="index" :label="item.desc" :value="item.code" :class="item.disabled?'none':''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件类型" prop="idType" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.idType">
              <el-radio v-for="(item,key) in $enums.idType" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="证件号码" prop="examineeIdNo" :rules="[$validate.string(22)]">
            <el-input v-model="form.examineeIdNo" :maxlength="22" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="专业名称" prop="specialtyName" :rules="[$validate.string(20)]">
            <el-input :disabled="form.isExotic==0" v-model="form.specialtyName" :maxlength="20" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="等级名称" prop="gradeName" :rules="[$validate.string(20)]">
            <el-input :disabled="form.isExotic==0" v-model="form.gradeName" :maxlength="20" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="考试结果" prop="evaluateResult" :rules="[$validate.string(20)]">
            <el-input v-model="form.evaluateResult" :maxlength="20" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', form)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
import Tool from '../../common/tool'

export default {
  name: 'performance-editUser',
  components: {},
  props: ['row'],
  data () {
    return {
      form: null,
      areaTreeData: [],
      nationalityList: []
    }
  },
  async created () {
    this.areaTreeData = await this.$HTTP.ApiCommon.getAreaTreeData()
    this.nationalityList = await this.$HTTP.ApiCommon.getNationality()
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async uploadOSS (event) {
      try {
        // if (event.file.size < 1024 * 100) {
        //   throw new Error('仅支持JPG、PNG格式图片文件，且文件大小大于100KB')
        // }
        this.form.certificateUrl = await this.$HTTP.ApiOss.uploadOSS(event.file, 'certificate', '.png,.jpg', 'exam-data')
        this.form.certificateUrl2 = await this.$HTTP.ApiOss.signatureUrl(this.form.certificateUrl, 'exam-data')
        this.$forceUpdate()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async userUploadOSS (event) {
      try {
        // if (event.file.size < 1024 * 100) {
        //   throw new Error('仅支持JPG、PNG格式图片文件，且文件大小大于100KB')
        // }
        this.form.officialPhoto = await this.$HTTP.ApiOss.uploadOSS(event.file, 'certificate', '.png,.jpg', 'ID-photo')
        this.form.officialPhoto2 = await this.$HTTP.ApiOss.signatureUrl(this.form.officialPhoto, 'ID-photo')
        this.$forceUpdate()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async toPinyin () {
      if (!Tool.isNull(this.form.examineeName)) {
        let examineeNameSpell = await this.$HTTP.ApiCommon.toPinyin(this.form.examineeName)
        console.log(examineeNameSpell)
        this.form.examineeNameSpell = examineeNameSpell
      } else {
        this.form.examineeNameSpell = null
      }
    },
    async initForm () {
      if (this.row.evaluateExamId) {
        let info = await this.$HTTP.GradeExam.getExamInfo(this.row.evaluateExamId)
        // info.examId = this.$route.query.examId
        info.certificateUrl2 = await this.$HTTP.ApiOss.signatureUrl(info.certificateUrl, 'exam-data')
        info.receiverAddressInfo2 = info.receiverAddressInfo ? info.receiverAddressInfo.split('/') : []
        info.birthday2 = info.birthday ? info.birthday.replace(/\./g, '-') : ''
        if (info.officialPhoto != null) {
          if (info.officialPhoto.indexOf("IDCard") != -1) {
            info.officialPhoto2 = await this.$HTTP.ApiOss.signatureUrl(info.officialPhoto, 'IDCard')
          } else {
            info.officialPhoto2 = await this.$HTTP.ApiOss.signatureUrl(info.officialPhoto, 'ID-photo')
          }
        }
        this.form = info
        if (this.Tool.isNull(this.form.examineeNameSpell)) {
          await this.toPinyin()
        }
      } else {
        throw new Error('evaluateExamId不能为空')
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        this.form.birthday = this.$moment(this.form.birthday2).format('YYYY.MM.DD')
        this.form.receiverAddressInfo = this.form.receiverAddressInfo2.join('/')
        await this.$HTTP.GradeExam.updateEvaluate(this.form)
        this.$message({ type: 'success', message: '操作成功' })
        // this.$router.replace({ path: './order', query: this.$route.query })
        this.$emit('close', this.form)
      }
    }
  }
}
</script>
<style scoped>
  .add-page {
    padding: 30px 0;
  }

  .text-right {
    position: absolute;
    bottom: 0;
    right: 40px;
    /*width: 100%;*/
    padding: 20px 0;
    background-color: #ffffff;
  }
</style>
